var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCampaignSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 14,
    fill: "#121212",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.15118V15.7375C20.0003 15.9128 19.9588 16.0859 19.8787 16.2436C19.7986 16.4012 19.6821 16.5393 19.538 16.6471C19.3258 16.8024 19.0668 16.8873 18.8 16.8889C18.7028 16.8886 18.6061 16.877 18.5119 16.8544L12.7997 15.4841L12.1277 15.3229H10.9997C10.2143 15.3228 9.46033 15.0273 8.8996 14.4997C8.47417 14.0994 8.1826 13.5866 8.06205 13.0267C7.9415 12.4669 7.99742 11.8852 8.2227 11.356C8.44797 10.8267 8.83239 10.3738 9.32696 10.0549C9.82153 9.7361 10.4038 9.56579 10.9997 9.56571H12.1277L18.5119 8.03428C18.6882 7.99207 18.8721 7.9888 19.0498 8.0247C19.2275 8.0606 19.3945 8.13474 19.538 8.24154C19.6821 8.34939 19.7986 8.48741 19.8787 8.64505C19.9588 8.8027 20.0003 8.97581 20 9.15118Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8887 16.2666V18.3995C12.8887 18.706 12.7679 19.0001 12.5528 19.2169C12.3377 19.4337 12.046 19.5555 11.7418 19.5555H11.0651C10.7959 19.5607 10.5336 19.4703 10.3239 19.3002C10.1142 19.13 9.97055 18.891 9.91811 18.6249L9.33316 15.5557C9.63973 15.7534 9.97702 15.898 10.331 15.9834C10.6047 16.0531 10.886 16.0881 11.1683 16.0874H12.1776L12.8887 16.2666Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignSvgrepoCom1);
export default __webpack_public_path__ + "static/media/campaign-svgrepo-com 1.c37d76454b649d3bccc2b2c84d157671.svg";
export { ForwardRef as ReactComponent };